import { createStyles, makeStyles } from '@material-ui/core';

export const RfqCommonDialogStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& .MuiPaper-root': {
        borderRadius: 16
      }
    },
    header: {
      margin: 0,
      padding: `19px 24px`
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    content: {
      padding: `0px 24px`
    },
    footer: {
      display: 'flex',
      padding: `17px 24px`
    },
    confirmButton: {
      flexGrow: 1
    }
  })
);
